import { TextTip } from '@@/Tip/TextTip';

export function PollingIntervalScopeTip() {
  return (
    <TextTip>
      This interval does not apply to edge stacks — it only applies to regular
      stacks.
    </TextTip>
  );
}
